const SCHOOL_ADMIN = 'User.Admin';
const USER_ROLE_USER = 'User.User';
const USER_ROLE_FLEET_ADMIN = 'fleet.manager';
const USER_ROLE_FLEET_MECHANIC = 'fleet.mechanic';
const USER_ROLE_TRANSPORTATION_MANAGER = 'transportation.manager';
const USER_ROLE_TRANSPORTATION_ADMIN = 'transportation.admin';
const USER_ROLE_TRANSPORTATION_ROUTER = 'transportation.router';
const SUPER_ADMIN = 'super.admin';
const PROFILE_REVIEW_ADMIN = 'profile.review.admin';
const USER_ROLE_COUNSELOR = 'school.counselor';
const USER_ROLE_OFF_CAMPUS_COORDINATOR = 'off_campus.coordinator';
// Off-campus admin work the coordinators choose in Off Campus settings
const USER_ROLE_OFF_CAMPUS_SECRETARY = 'off_campus.secretary';
// A student signed in as themselves through the student Microsoft app (#602)
const USER_ROLE_STUDENT = 'Student.User';
const USER_ROLE_TEACHER = 'school.teacher';
const USER_ROLE_FINANCE_ADMIN = 'finance.admin';
const USER_ROLE_SCHOOL_PRINCIPAL = 'school.principal';
const BUILDINGS_ADMIN = 'buildings.admin';
const BUILDINGS_EDITOR = 'buildings.editor';
const BUILDINGS_VIEWER = 'buildings.viewer';
const HOMESCHOOL_FACILITATOR = 'homeschool.facilitator';
const HOMESCHOOL_ADMIN = 'homeschool.admin';
const IT_ADMIN = 'it.admin';

const NEXT_YEAR_PICKUP_LABELS = {
  yard: 'Yard',
  group: 'Group',
  intowndoor: 'In-Town Door',
  walk: 'Walk',
  ruraldriveway: 'Rural Driveway',
};

const SCHOOLS = [
  {
    schoolName: 'Blue Hills Community School',
    schoolNumber: 1713,
    schoolAbbreviation: 'BHCS',
    grades: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    community: 'Blue Hills',
  },
  {
    schoolName: 'Buffalo Head Prairie School',
    schoolNumber: 1701,
    schoolAbbreviation: 'BHPS',
    grades: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    community: 'Buffalo Head Prairie',
  },
  { schoolName: 'De Oabeit Collegiate School', schoolNumber: 2633, schoolAbbreviation: 'DOCS' },
  { schoolName: 'FVSD Summer', schoolNumber: 17159, schoolAbbreviation: 'FVSDS' },
  {
    schoolName: 'Florence MacDougall Community School',
    schoolNumber: 1709,
    schoolAbbreviation: 'FMCS',
    grades: [0, 1, 2, 3],
    community: 'High Level',
  },
  {
    schoolName: 'Fort Vermilion Public School',
    schoolNumber: 1702,
    schoolAbbreviation: 'FVPS',
    grades: [7, 8, 9, 10, 11, 12],
    community: 'Fort Vermilion',
  },
  {
    schoolName: 'Gramson Centre Collegiate School',
    schoolNumber: 2634,
    schoolAbbreviation: 'GCCS',
  },
  {
    schoolName: 'High Level Public School',
    schoolNumber: 1703,
    schoolAbbreviation: 'HLPS',
    grades: [7, 8, 9, 10, 11, 12],
    community: 'High Level',
  },
  {
    schoolName: 'Hillcrest Community School',
    schoolNumber: 1712,
    schoolAbbreviation: 'HCCS',
    grades: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    community: 'Blumenort',
    ECSSchedulePreference: ['Tuesday/Thursday', 'Wednesday/Friday'],
  },
  {
    schoolName: 'La Crete Public School',
    schoolNumber: 1704,
    schoolAbbreviation: 'LCPS',
    grades: [7, 8, 9, 10, 11, 12],
    community: 'La Crete',
  },
  { schoolName: 'Northern Outreach Center', schoolNumber: 1742, schoolAbbreviation: 'NOC' },
  {
    schoolName: 'Pathways',
    schoolNumber: 2454,
    schoolAbbreviation: 'PATH',
    grades: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  { schoolName: 'Pathways Summer', schoolNumber: 24549, schoolAbbreviation: 'PATHS' },
  {
    schoolName: 'Rainbow Lake School',
    schoolNumber: 1705,
    schoolAbbreviation: 'RLKS',
    grades: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    community: 'Rainbow Lake',
  },
  {
    schoolName: 'Ridgeview Central School',
    schoolNumber: 1714,
    schoolAbbreviation: 'RVCS',
    grades: [4, 5, 6],
    community: 'La Crete',
  },
  {
    schoolName: 'Rocky Lane School',
    schoolNumber: 1706,
    schoolAbbreviation: 'RLNS',
    grades: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    community: 'Rocky Lane',
  },
  {
    schoolName: 'Sandhills Elementary School',
    schoolNumber: 1794,
    schoolAbbreviation: 'SHES',
    grades: [0, 1, 2, 3],
    community: 'La Crete',
    ECSSchedulePreference: ['Monday/Wednesday', 'Tuesday/Thursday'],
  },
  {
    schoolName: 'Sipiwan Centre 15 Collegiate School',
    schoolNumber: 2635,
    schoolAbbreviation: 'SCCS',
  },
  {
    schoolName: 'Spirit of the North Community School',
    schoolNumber: 487,
    schoolAbbreviation: 'SNCS',
    grades: [4, 5, 6],
    community: 'High Level',
  },
  {
    schoolName: 'St. Mary’s Catholic School',
    schoolNumber: 1770,
    schoolAbbreviation: 'SMCS',
    grades: [0, 1, 2, 3, 4, 5, 6],
    community: 'Fort Vermilion',
  },
  {
    schoolName: 'Upper Hay River School',
    schoolNumber: 1791,
    schoolAbbreviation: 'UHRS',
    grades: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    community: 'Meander River',
  },
];

const HOME_ED_SCHOOL_CODES = [1742];

// Off-campus prerequisite courses, and which one each program needs: AGR 3000
// for Green Certificate, HCS 3000 for every other program. Mirrored in
// server/constants.js and held in lockstep by server/constants.sync.test.js.
const OFF_CAMPUS_PREREQUISITES = ['HCS3000', 'AGR3000'];
const OFF_CAMPUS_PROGRAM_PREREQUISITES = { WE: 'HCS3000', CI: 'HCS3000', RAP: 'HCS3000', GC: 'AGR3000' };
// Green Certificate training specializations, as listed on the GC Registration
// Form (2026-2027). Mirrored in server/constants.js and held in lockstep by
// server/constants.sync.test.js.
const OFF_CAMPUS_GC_SPECIALIZATIONS = [
  { value: 'beekeeping', label: 'Beekeeping' },
  { value: 'cow_calf', label: 'Cow-Calf' },
  { value: 'dairy', label: 'Dairy' },
  { value: 'equine', label: 'Equine' },
  { value: 'feedlot', label: 'Feedlot' },
  { value: 'field_crop', label: 'Field Crop' },
  { value: 'greenhouse', label: 'Greenhouse' },
  { value: 'irrigated_crop', label: 'Irrigated Crop' },
  { value: 'sheep', label: 'Sheep' },
  { value: 'swine', label: 'Swine' },
  { value: 'poultry_broiler', label: 'Poultry – Broiler' },
  { value: 'poultry_hatching_egg', label: 'Poultry – Hatching Egg' },
  { value: 'poultry_table_egg', label: 'Poultry – Table Egg' },
  { value: 'poultry_turkey', label: 'Poultry – Turkey' },
];
// The Green Certificate modules a course mark is recorded against. These are the
// GC program levels in coordinator-evaluation-form.js, which is kept verbatim on
// both sides so is not imported here. Mirrored in server/constants.js and held in
// lockstep by server/constants.sync.test.js.
const OFF_CAMPUS_GC_MODULES = ['X', 'Y', 'Z'];
// The off-campus programs a referral or placement can be in, as offered in the
// program pickers. Values match the placement model's programType enum.
// The Green Certificate program's code, which the worksite picker keys on (#646).
// Mirrored in server/constants.js and held in lockstep by constants.sync.test.js.
const OFF_CAMPUS_GC_PROGRAM = 'GC';
const OFF_CAMPUS_PROGRAMS = [
  { value: 'WE', label: 'Work Experience' },
  { value: 'CI', label: 'Career Internship' },
  { value: 'RAP', label: 'Registered Apprenticeship Program' },
  { value: 'GC', label: 'Green Certificate' },
];

module.exports = {
  HOME_ED_SCHOOL_CODES,
  ROLES: {
    SCHOOL_ADMIN,
    USER_ROLE_USER,
    USER_ROLE_FLEET_ADMIN,
    USER_ROLE_FLEET_MECHANIC,
    USER_ROLE_TRANSPORTATION_MANAGER,
    USER_ROLE_TRANSPORTATION_ADMIN,
    USER_ROLE_TRANSPORTATION_ROUTER,
    SUPER_ADMIN,
    PROFILE_REVIEW_ADMIN,
    USER_ROLE_COUNSELOR,
    USER_ROLE_OFF_CAMPUS_COORDINATOR,
    USER_ROLE_OFF_CAMPUS_SECRETARY,
    USER_ROLE_TEACHER,
    USER_ROLE_FINANCE_ADMIN,
    USER_ROLE_SCHOOL_PRINCIPAL,
    BUILDINGS_ADMIN,
    BUILDINGS_EDITOR,
    BUILDINGS_VIEWER,
    HOMESCHOOL_FACILITATOR,
    HOMESCHOOL_ADMIN,
    IT_ADMIN,
    USER_ROLE_STUDENT,
  },
  SCHOOLS,
  NEXT_YEAR_PICKUP_LABELS,
  OFF_CAMPUS_PREREQUISITES,
  OFF_CAMPUS_PROGRAM_PREREQUISITES,
  OFF_CAMPUS_PROGRAMS,
  OFF_CAMPUS_GC_PROGRAM,
  OFF_CAMPUS_GC_SPECIALIZATIONS,
  OFF_CAMPUS_GC_MODULES,
};
